import { capitalizeWord, convertDecimalCurrency } from '../../utils/utils'

export const checkFormaPagamento = (forma) => {
  const regex = /Visa|Master|Amex|Elo|Diners|Boleto|Bonificação/

  if (typeof forma === 'string') {
    return regex.exec(capitalizeWord(forma))[0]
  }
}

export const changePagamentoMessage = (pedido) => {
  const formaPagamento = pedido?.DetalhePagamento?.DescricaoFormaPagamento

  const condicaoPagamento = pedido?.DetalhePagamento?.DescricaoCondicaoPagamento

  const juros = pedido?.DetalhePagamento?.Juros

  const quantidadeParcelas = pedido?.DetalhePagamento?.QuantidadeParcelas

  const valorParcelas = pedido?.DetalhePagamento?.ValorParcelas

  if (formaPagamento === 'Boleto Bancário Gimba Faturado' && juros > 0) {
    return `${condicaoPagamento} ${juros.toString().replace('.', ',')}%`
  } else if (formaPagamento === 'Boleto Bancário Gimba Faturado') {
    return condicaoPagamento
  }

  if (formaPagamento === 'Boleto à vista') {
    return condicaoPagamento
  }

  if (formaPagamento === 'Pix') {
    return condicaoPagamento.toUpperCase()
  }

  if (formaPagamento?.includes('Cartão')) {
    if (juros === 0) {
      return `Em ${quantidadeParcelas}x de ${convertDecimalCurrency(
        valorParcelas
      )} sem juros`
    } else {
      return `Em ${quantidadeParcelas}x de ${convertDecimalCurrency(
        valorParcelas
      )} com juros de ${juros?.toString().replace('.', ',')}%`
    }
  }
}
